export const fileData = {
    id: null,
    filename: '',
    path: '',
    name: '',
    comment: '',
    hide: false,
    size: 0,
    ext: '',
}
export const fileMediaData = {
    duration: 0,
    timeout: 0,
    playEndless: false,
}
const logoData = {
    base64: 'data:image/jpeg;base64,',
    height: 20,
    width: 20
}
const textDescription = {
    text: '',
    size: 20,
    color: '#0086cf',
}

const buttons = {
    text: textDescription,
    background: '#0086cf',
    stroke: '',
    label_type: 0,
    label: '',
    radius: 0,
}
export const buttonExt = {
    cellCode: 0,
    description: '',
    ...buttons
}
export const firstScreen = {
    audio: fileData,
    audioData: fileMediaData,
    background: undefined,
    buttons: buttons,
    buttons_busy: buttons,
    buttonsExt: [{ ...buttonExt }],
    logo: fileData,
    logo_base64: undefined,
    logo_only: false,
    logo_width: 0,
    logo_height: 0,
    order: 0,
    text1: textDescription,
    text2: textDescription,
    toolbar: '',
    video1: fileData,
    video2: fileData,
    videoData1: fileMediaData,
    videoData2: fileMediaData,
}

const thirdScreen = {
    buttons2: buttons,
    ...firstScreen
}
const fourthScreen = {
    background: '',
    toolbar: '',
    buttons: buttons,
    sum_full_tank: '',
    show_full_tank: false,
    order: 0,
}
const finalScreen = {
    background: '',
    text1: textDescription,
    text2: textDescription,
    text3: textDescription,
    show_qr: false,
    order: 0
}
export const fifthScreen = {
    background: '#ffffff',
    button1: buttons,
    button2: buttons,
    logoCardFile: fileData,
    logoCardData: logoData,
    logoCashFile: fileData,
    logoCashData: logoData,
    logoQrFile: fileData,
    logoQrData: logoData,
    logoStaffFile: fileData,
    logoStaffData: logoData,
    logoScanFile: fileData,
    logoScanData: logoData,
    order: 0,
    showButton: false,
    textAboveLogoCard: textDescription,
    textBelowLogoCard: textDescription,
    textAboveLogoCash: textDescription,
    textBelowLogoCash: textDescription,
    textAboveLogoQr: textDescription,
    textBelowLogoQr: textDescription,
    textAboveLogoStaff: textDescription,
    textBelowLogoStaff: textDescription,
    textAboveLogoScan: textDescription,
    textBelowLogoScan: textDescription,
    toolbar: '#ffffff'
}
export const interfaceDescription = {
     first_screen: firstScreen,
     second_screen: firstScreen,
     third_screen: thirdScreen,
     fourth_screen: fourthScreen,
    fifthScreen: fifthScreen,
     error_screen: firstScreen,
     final_screen: finalScreen,
     screens: [{ ...firstScreen }]
}

export const posPointBucketScreen = {
    logo: fileData,
    logoBase64: undefined,
    logoWidth: 0,
    logoHeight: 0,
    logoOnly: false,
    logo2: fileData,
    logo2Base64: undefined,
    logo2Width: 0,
    logo2Height: 0,
    background: '#ffffff',
    background2: '#ffffff',
    toolbar: '',
    text: textDescription,
    text2: textDescription,
    text3: textDescription,
    button: buttons,
    button2: buttons,
}

export const posPointChooseGoodsScreen = {
    logo: fileData,
    logoBase64: undefined,
    logoWidth: 0,
    logoHeight: 0,
    logoOnly: false,
    background: '#ffffff',
    toolbar: '',
    text: textDescription,
    button: buttons,
    button2: buttons,
    button3: buttons,
    button4: buttons,
}

export const posPointChoosePaymentScreen = {
    order: 0,
    logo: fileData,
    logoBase64: undefined,
    logoWidth: 0,
    logoHeight: 0,
    logoOnly: false,
    logo2: fileData,
    logo2Base64: undefined,
    logo2Width: 0,
    logo2Height: 0,
    logo3: fileData,
    logo3Base64: undefined,
    logo3Width: 0,
    logo3Height: 0,
    logo4: fileData,
    logo4Base64: undefined,
    logo4Width: 0,
    logo4Height: 0,
    logo5: fileData,
    logo5Base64: undefined,
    logo5Width: 0,
    logo5Height: 0,
    logo6: fileData,
    logo6Base64: undefined,
    logo6Width: 0,
    logo6Height: 0,
    background: '#ffffff',
    toolbar: '',
    text: textDescription,
    text2: textDescription,
    button: buttons,
}
